import React from 'react';
import { useShowContextRequired } from 'ui-builder';
import { PreviewDocumentWidget } from 'features/nekst-widgets';
import {
  ProjectDocument,
} from 'nekst-api';

export default function PreviewDocumentField() {
  const showContext = useShowContextRequired<ProjectDocument>();
  const document = showContext.data;

  return (
    <PreviewDocumentWidget document={document} />
  );
}
